module.exports = __webpack_public_path__ + "img/gallery1111.369b8c47.jpg";